<div class="forgot-password">
  <div class="container forgot-password-container">
    <div class="container-header no-bottom-border">
      <div class="text">Forgot password</div>
    </div>
    <div *ngIf="!emailSent" class="container-content">
      <div class="container-row desc-row">
        Enter your email to reset your password. An email will be sent to you
        containing a link that will allow you to reset your password
      </div>
      <div class="container-row">
        <svg-icon src="assets/svg/envelope-circle.svg"></svg-icon>
        <lhpe-input
          class="input"
          controlName="email"
          placeholder="Email"
          [formGroup]="forgotPasswordForm"
        >
        </lhpe-input>
      </div>
      <div class="container-row submit-row">
        <button
          mat-button
          color="lightGreen"
          [disabled]="forgotPasswordForm.invalid"
          (click)="submitForgotPassword()"
        >
          Submit
        </button>
      </div>
    </div>
    <div *ngIf="emailSent" class="container-content">
      <div class="container-row desc-row">
        A password reset email has been sent to the email address provided.
      </div>
    </div>
  </div>
</div>
